import { ref, onMounted } from 'vue'
import { ItemWrapper } from '@/wrappers'
import { CubeIcon } from '@heroicons/vue/24/outline'
import type { Resource, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useResource(skipLoading: boolean = false) {

    const baseForm: FormData = {
        name: null,
        price: null
    };

    const wrapper = new ItemWrapper<Resource>("resources");

    const empty = {...baseForm};

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const resources = ref<Resource[]>([]);
    const resourceOptions = ref<FormSelectOption[]>([]);

    async function addResource(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading}

        await wrapper.addItem(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.data = {...empty};
        request.value.isLoading = !request.value.isLoading;
    }

    function getAsFormOptions(): void {
        resourceOptions.value = resources.value.map(resource => {
            return {
                value: resource.id,
                label: resource.name,
                command: `€ ${resource.price}`,
                icon: CubeIcon
            }
        });
    }

    async function getResources(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getItems().then((data) => resources.value = data);

        getAsFormOptions();
        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }

    onMounted(() => {
        if (skipLoading) return;

        getResources();
    });

    return {
        info,
        request,
        resources,
        resourceOptions,
        getInfo,
        addResource,
        getResources
    }
}